
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    appBar: {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    toolbar: {
      flexWrap: "wrap",
    },
    toolbarTitle: {
      flexGrow: 1,
      marginLeft: "2rem",
    },
    toolbarTitleImage: {
      width: "auto",
      height: "3rem",
      margin: "1rem",
      filter: "invert(1)",
    },
  
    link: {
      margin: theme.spacing(1, 1.5),
      color: "white",
      textDecoration: 'none',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      letterSpacing: '0.05em',
    },
  }));

export default useStyles